import React from 'react';
import { useCompanyCapabilities, type UseCompanyCapabilitiesResult } from '../../hooks/useCompanyCapabilities';

/** Class-component adapter for useCompanyCapabilities, mirroring withWriteAccess. */
export interface WithCompanyCapabilitiesProps {
  companyCapabilities: UseCompanyCapabilitiesResult;
}

export function withCompanyCapabilities<P extends WithCompanyCapabilitiesProps>(
  Wrapped: React.ComponentType<P>,
): React.FC<Omit<P, 'companyCapabilities'>> {
  const WithCapabilities: React.FC<Omit<P, 'companyCapabilities'>> = (props) => {
    const companyCapabilities = useCompanyCapabilities();
    return <Wrapped {...(props as P)} companyCapabilities={companyCapabilities} />;
  };
  WithCapabilities.displayName = `withCompanyCapabilities(${Wrapped.displayName || Wrapped.name || 'Component'})`;
  return WithCapabilities;
}

export default withCompanyCapabilities;
